var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDistractedDrivingEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Distracted Driving Events",
    role: "img",
    viewBox: "0 0 100 150",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Distracted Driving Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5,12.5v125h75v-125H12.5 M12.5,0h75C94.4036,0,100,5.5964,100,12.5v125c0,6.9036-5.5964,12.5-12.5,12.5 h-75C5.5964,150,0,144.4036,0,137.5v-125C0,5.5964,5.5964,0,12.5,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.75,37.5H6.25V25h87.5V37.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.75,125H6.25v-12.5h87.5V125z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistractedDrivingEvents);
export default __webpack_public_path__ + "static/media/distracted-driving-events.7caaf78678cacb591393e0fe15d1b304.svg";
export { ForwardRef as ReactComponent };